export default __webpack_public_path__ + "static/media/dispatch_later_category.ca46c67f.svg";